import { Component, ChangeDetectionStrategy } from '@angular/core';
import { BookingService, BookingStore } from '@store';

@Component({
  selector: 'app-voucher-subscription-summary',
  templateUrl: './voucher-subscription-summary.component.html',
  styleUrls: ['./voucher-subscription-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VoucherSubscriptionSummaryComponent {
  constructor(public bookingStore: BookingStore, public bookingService: BookingService) {}
}
